module Meevo.Plugins.SystemToolbox {

    import IMaintenanceFormCustomButton = Meevo.Components.Controls.IMaintenanceFormCustomButton;

    export class TokenMigrationSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<null>{

        private securityKeys = Meevo.Components.Common.SecurityKeys;
        public exportHeaderId: string
        public importStatus: Meevo.Model.ImportStatusEnum;
        public exportStatus: Meevo.Model.ExportStatusEnum;
        public mappingFileId: string;
        public merchantAccountsMapped: number = 0;
        public tokensAvailableToActivate: number = 0;
        public exportMessage: string;
        public exportMessageClass: string;
        public importMessage: string;
        public importMessageClass: string;
        public isDownloadLinkVisible: boolean;
        public isUploadLinkVisible: boolean;
        private selectedMerchantAccountId: string;
        private selectedMultiLocation: number[];
        public auditNoun = Meevo.Model.NounEnum.SystemToolboxTokenMigration;
        public customAuditCriteria = {
            nounId: Meevo.Model.NounEnum.SystemToolboxTokenMigrationActions
        };

        public customButtonsSet: Array<IMaintenanceFormCustomButton>;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            private securityService: Meevo.Components.Common.ISecurityService,
            noun: Meevo.Model.NounEnum,
            appSettings: Components.Common.IAppSettings,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey: string,
            private context: SystemToolboxContext,
            private $q: ng.IQService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private $translate: ng.translate.ITranslateService,
            private $http: ng.IHttpService,
            private $timeout: ng.ITimeoutService
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey, $translate);

            this.customButtonsSet = [{
                text: 'LABEL_CANCEL_MIGRATION',
                classNames: 'meevo-button-lg meevo-bottom-button button-cancel-migration',
                clickHandler: () => {
                    this.modalService.yellowConfirm('MESSAGE_CANCEL_ACTIVE_MIGRATION', Meevo.Components.Modal.ModalTranslationModes.Translate).then(() => {
                        const request = {
                            exportHeaderId: this.exportHeaderId
                        };

                        this.dataService.customMethodData("/api/tokenMigration/cancel", "POST", request).then((response) => {
                            this.updateStatus(response.data);
                        });
                    });
                },
                disableRules: () => false,
                visibilityRules: () => this.isCancelTokenMigrationButtonVisible,
                securityRules: null,
                position: 'left'
            }];
        }

        get isCancelTokenMigrationButtonVisible(): boolean {
            return this.importStatus === Meevo.Model.ImportStatusEnum.New
                || this.importStatus === Meevo.Model.ImportStatusEnum.Imported
                || this.importStatus === Meevo.Model.ImportStatusEnum.Failed
                || this.importStatus === Meevo.Model.ImportStatusEnum.PublishedFailed;
        }

        selected(subSectionContentKey?: string) {
            this.getTokenMigrationStatus();
        }

        public isGenerateMappingFileEnabled(exportStatus: Meevo.Model.ExportStatusEnum): boolean {
            switch (exportStatus) {
                case Meevo.Model.ExportStatusEnum.New:
                case Meevo.Model.ExportStatusEnum.Processing:
                    return false;
            }

            return true;
        }

        public isActivateTokensEnabled(importStatus: Meevo.Model.ImportStatusEnum): boolean {
            return importStatus === Meevo.Model.ImportStatusEnum.Imported;
        }

        private updateStatus(data) {
            this.exportHeaderId = data.exportHeaderId;
            this.importStatus = data.importStatus;
            this.exportStatus = data.exportStatus;
            this.mappingFileId = data.mappingFileId;
            this.merchantAccountsMapped = data.merchantAccountsMapped;
            this.tokensAvailableToActivate = data.tokensAvailableToActivate;

            this.exportMessage = '';
            this.exportMessageClass = '';
            this.isDownloadLinkVisible = false;
            this.importMessage = '';
            this.importMessageClass = '';
            this.isUploadLinkVisible = false;

            switch (this.exportStatus) {
                case Meevo.Model.ExportStatusEnum.New:
                case Meevo.Model.ExportStatusEnum.Processing:
                    this.exportMessage = this.$translate.instant("LABEL_GENERATE_MAPPING_FILE_PROGRESS");
                    break;

                case Meevo.Model.ExportStatusEnum.FileGenerated:
                    this.exportMessage = this.$translate.instant("LABEL_GENERATE_MAPPING_FILE_SUCCESSFUL");
                    this.exportMessageClass = 'message-success';
                    this.isDownloadLinkVisible = true;

                    switch (this.importStatus) {
                        case Meevo.Model.ImportStatusEnum.New:
                            if (data.isImportInProgress) {
                                this.importMessage = this.$translate.instant("LABEL_IMPORT_TOKENS_PROGRESS");
                            } else {
                                this.isUploadLinkVisible = true;
                            }
                            break;

                        case Meevo.Model.ImportStatusEnum.Processing:
                            this.importMessage = data.isActivateInProgress
                                ? this.$translate.instant("LABEL_ACTIVATE_TOKENS_PROGRESS")
                                : this.$translate.instant("LABEL_IMPORT_TOKENS_PROGRESS");
                            break;

                        case Meevo.Model.ImportStatusEnum.Imported:
                            this.importMessage = this.$translate.instant("LABEL_IMPORT_TOKENS_SUCCESSFUL");
                            this.importMessageClass = 'message-success';
                            break;

                        case Meevo.Model.ImportStatusEnum.Failed:
                            this.importMessage = this.$translate.instant("LABEL_IMPORT_TOKENS_FAILED");
                            this.importMessageClass = 'message-failure';
                            break;

                        case Meevo.Model.ImportStatusEnum.InitiatePublishing:
                            this.importMessage = this.$translate.instant("LABEL_ACTIVATE_TOKENS_PROGRESS");
                            break;

                        case Meevo.Model.ImportStatusEnum.PublishedFailed:
                            this.importMessage = this.$translate.instant("LABEL_ACTIVATE_TOKENS_FAILED");
                            this.importMessageClass = 'message-failure';
                            break;
                    }
                    break;

                case Meevo.Model.ExportStatusEnum.Failed:
                    this.exportMessage = this.$translate.instant("LABEL_GENERATE_MAPPING_FILE_FAILED");
                    this.exportMessageClass = 'message-failure';
                    break;
            }
        }

        private getTokenMigrationStatus() {
            return this.dataService.customMethodData("/api/tokenMigration/status", "GET", null).then((response) => {
                this.updateStatus(response.data);
            });
        }

        public generateMappingFile() {
            this.getTokenMigrationStatus().then(() => {
                if (!this.isGenerateMappingFileEnabled(this.exportStatus)) {
                    const message = this.$translate.instant("LABEL_GENERATE_MAPPING_FILE_CONCURRENT");
                    return this.modalService.alert(message);
                }

                switch (this.exportStatus) {
                    case Meevo.Model.ExportStatusEnum.New:
                    case Meevo.Model.ExportStatusEnum.FileGenerated:
                        const message1 = this.$translate.instant("LABEL_GENERATE_MAPPING_FILE_SUBSEQUENT_1");
                        const message2 = this.$translate.instant("LABEL_GENERATE_MAPPING_FILE_SUBSEQUENT_2");
                        const message = `${message1}<br><br>${message2}`;

                        return this.modalService.yellowConfirm(message).then(() => {
                            return this.continueGenerateMappingFile();
                        });
                }

                return this.continueGenerateMappingFile();
            });
        }

        private continueGenerateMappingFile() {
            if (this.identityService.inCentralOfficeMode()) {
                return this.selectMultiLocation().then(() => {
                    return this._continueGenerateMappingFile();
                });
            }

            return this._continueGenerateMappingFile();
        }

        private _continueGenerateMappingFile() {
            const request = {
                exportHeaderId: this.exportHeaderId,
                locations: this.selectedMultiLocation,
            };

            this.busyService.start();
            return this.dataService.customMethodData("/api/tokenMigration/generateMapping", "POST", request).then((response) => {
                this.busyService.stop();

                if (!response.data.isSuccess) {
                    return this.modalService.alert(response.data.error);
                }

                this.updateStatus(response.data.status);

                const message = this.$translate.instant("LABEL_GENERATE_MAPPING_FILE_SUCCESS");
                return this.modalService.alert(message);
            }).finally(() => {
                this.busyService.stop();
            });
        };

        public activateTokens() {
            this.getTokenMigrationStatus().then(() => {
                if (!this.isActivateTokensEnabled(this.importStatus)) {
                    const message = this.$translate.instant("LABEL_ACTIVATE_IMPORTED_TOKENS_CONCURRENT");
                    return this.modalService.alert(message);
                }

                if (this.tokensAvailableToActivate === 0) {
                    const message = this.$translate.instant("LABEL_ACTIVATE_IMPORTED_TOKENS_ZERO");
                    return this.modalService.alert(message);
                }

                const _showWarning = (request) => {
                    const message1 = this.$translate.instant("LABEL_ACTIVATE_IMPORTED_TOKENS_WARNING_1");
                    const message2 = this.$translate.instant("LABEL_ACTIVATE_IMPORTED_TOKENS_WARNING_2");
                    const message = `${message1}<br><br>${message2}`;

                    const options = {
                        okButtonContentKey: 'LABEL_YES',
                        cancelButtonContentKey: 'LABEL_NO',
                        showCancelButton: true,
                    };

                    return this.modalService.warning(message, Components.Modal.ModalTranslationModes.DoNotTranslate, true, options).then((result) => {
                        if (!result) {
                            return;
                        }

                        return this.continueActivateTokens(request);
                    });
                };

                if (this.identityService.inCentralOfficeMode()) {
                    return this.selectMerchantAccounts().then((selectedMerchantAccounts) => {
                        const request = {
                            exportHeaderId: this.exportHeaderId,
                            merchantAccountList: selectedMerchantAccounts,
                        };

                        return _showWarning(request);
                    });
                }

                return this.selectMerchantAccount().then(() => {
                    const request = {
                        exportHeaderId: this.exportHeaderId,
                        merchantAccountId: this.selectedMerchantAccountId,
                    };

                    return _showWarning(request);
                });
            });
        }

        private continueActivateTokens(request) {
            this.busyService.start();
            return this.dataService.customMethodData("/api/tokenMigration/activateTokens", "POST", request).then((response) => {
                this.busyService.stop();

                if (!response.data.isSuccess) {
                    return this.modalService.alert(response.data.error);
                }

                this.updateStatus(response.data.status);

                const message = this.$translate.instant("LABEL_ACTIVATE_IMPORTED_TOKENS_SUCCESS");
                return this.modalService.alert(message);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        private showSelectMultiLocationModal(): ng.IPromise<number[]> {
            const modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/systemToolbox/selectMultiLocation/selectMultiLocationModal.template.html",
                controller: "meevo.plugins.systemToolbox.SelectMultiLocationModalController",
                controllerAs: "vm",
                bindToController: true,
                multiple: true,
                locals: {
                    multiLocationList: this.context.multiLocationList,
                }
            };

            return this.modalService.showCustom(modalOptions).then((locations: number[]) => {
                return this.$q.resolve(locations);
            });
        }

        private selectMultiLocation(): ng.IPromise<number[]> {
            // select first location if only one exists
            if (this.context.multiLocationList.length === 1) {
                this.selectedMultiLocation = [ this.context.multiLocationList[0].locationId ];
                return this.$q.resolve(this.selectedMultiLocation);
            }

            return this.showSelectMultiLocationModal().then((response: any) => {
                if (!response) {
                    // user clicked close/cancel
                    return this.$q.reject();
                }

                if (response === 'excluded') {
                    // user excluded all locations
                    return this.modalService.alert('MESSAGE_ALL_LOCATIONS_EXCLUDED').then(() => {
                        return this.$q.reject();
                    });
                }

                this.selectedMultiLocation = response;

                return this.$q.resolve(this.selectedMultiLocation);
            });
        }

        private showSelectMerchantAccountModal(): ng.IPromise<string> {
            const modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/systemToolbox/selectMerchantAccount/selectMerchantAccountModal.template.html",
                controller: "meevo.plugins.systemToolbox.SelectMerchantAccountModalController",
                controllerAs: "vm",
                bindToController: true,
                multiple: true,
                locals: {
                    meevoPayMerchantAccounts: this.context.meevoPayMerchantAccounts,
                }
            };

            return this.modalService.showCustom(modalOptions).then((selectedMerchantAccountId: string) => {
                return this.$q.resolve(selectedMerchantAccountId);
            });
        }

        private selectMerchantAccount(): ng.IPromise<Model.MerchantAccount> {
            const noActiveMeevoPay = () => {
                this.selectedMerchantAccountId = null;

                const message = this.$translate.instant("LABEL_NO_ACTIVE_MEEVOPAY");
                return this.modalService.alert(message).then(() => {
                    return this.$q.reject();
                });
            };

            return this.context.getMerchantAccounts().then(() => {
                // if no active merchant accounts, then show alert
                if (this.context.meevoPayMerchantAccounts.length === 0) {
                    return noActiveMeevoPay();
                };

                // if selected merchant account is set but no longer valid, then unset it
                if (this.selectedMerchantAccountId &&
                    !this.context.meevoPayMerchantAccounts.find(x => x.id == this.selectedMerchantAccountId)) {
                    this.selectedMerchantAccountId = null;
                }

                if (this.selectedMerchantAccountId) {
                    return this.$q.resolve(this.selectedMerchantAccountId);
                }

                // select first merchant account if only one exists
                if (this.context.meevoPayMerchantAccounts.length === 1) {
                    this.selectedMerchantAccountId = this.context.meevoPayMerchantAccounts[0].id;
                    return this.$q.resolve(this.selectedMerchantAccountId);
                }

                // select merchant account
                return this.showSelectMerchantAccountModal().then((selectedMerchantAccountId: string) => {
                    if (!selectedMerchantAccountId) {
                        // user clicked close/cancel
                        return this.$q.reject();
                    }

                    return this.context.getMerchantAccounts().then(() => {
                        // if no active merchant accounts, then show alert
                        if (this.context.meevoPayMerchantAccounts.length === 0) {
                            return noActiveMeevoPay();
                        };

                        this.selectedMerchantAccountId = selectedMerchantAccountId;

                        this.publishSelectMerchantAccountAudit();

                        return this.$q.resolve(this.selectedMerchantAccountId);
                    });
                });
            });
        }

        private showSelectMerchantAccountsModal(): ng.IPromise<any> {
            const modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/systemToolbox/selectMerchantAccounts/selectMerchantAccountsModal.template.html",
                controller: "meevo.plugins.systemToolbox.SelectMerchantAccountsModalController",
                controllerAs: "vm",
                bindToController: true,
                multiple: true,
                locals: {
                    multiLocationList: this.context.multiLocationList,
                },
            };

            return this.modalService.showCustom(modalOptions).then((selectedMerchantAccounts: any) => {
                return this.$q.resolve(selectedMerchantAccounts);
            });
        }

        private selectMerchantAccounts(): ng.IPromise<any> {
            return this.context.getMerchantAccountsCO().then(() => {
                for (const location of this.context.multiLocationList) {
                    const meevoPayMerchantAccounts = location['meevoPayMerchantAccounts'];
                    if (meevoPayMerchantAccounts.length === 1) {
                        location['selectedMerchantAccountId'] = meevoPayMerchantAccounts[0].id;
                    }
                }

                for (const location of this.context.multiLocationList) {
                    // if selected merchant account is set but no longer valid, then unset it
                    const selectedMerchantAccountId = location['selectedMerchantAccountId'];
                    if (!selectedMerchantAccountId) {
                        continue;
                    }

                    const meevoPayMerchantAccounts = location['meevoPayMerchantAccounts'];
                    if (!meevoPayMerchantAccounts.find(merchantAccount => merchantAccount.id == selectedMerchantAccountId)) {
                        location['selectedMerchantAccountId'] = null;
                    }
                }

                const selectionRequired = _(this.context.multiLocationList).some(location => !location['selectedMerchantAccountId']);

                if (!selectionRequired) {
                    const selectedMerchantAccounts = {};
                    for (const location of this.context.multiLocationList) {
                        selectedMerchantAccounts[location.locationId] = location['selectedMerchantAccountId'];
                    }

                    return this.$q.resolve(selectedMerchantAccounts);
                }

                return this.showSelectMerchantAccountsModal().then((selectedMerchantAccounts: any) => {
                    if (!selectedMerchantAccounts) {
                        // user clicked close/cancel
                        return this.$q.reject();
                    }

                    this.publishSelectMerchantAccountsAudit(selectedMerchantAccounts);

                    return this.$q.resolve(selectedMerchantAccounts);
                });
            });
        }

        private publishSelectMerchantAccountAudit() {
            const request = {
                exportHeaderId: this.exportHeaderId,
                merchantAccountId: this.selectedMerchantAccountId,
            };

            this.dataService.customMethodData("/api/tokenMigration/selectMerchantAccount", "POST", request);
        }

        private publishSelectMerchantAccountsAudit(selectedMerchantAccounts) {
            const request = {
                exportHeaderId: this.exportHeaderId,
                merchantAccountList: selectedMerchantAccounts,
            };

            this.dataService.customMethodData("/api/tokenMigration/selectMerchantAccount", "POST", request);
        }

        public downloadMappingFile() {
            this.$http({
                method: 'GET',
                url: `api/tokenMigration/mappingFile/${this.exportHeaderId}`,
                responseType: 'blob'
            }).then((response) => {
                const blob = new Blob([<any>response.data], { type: response.headers('Content-Type') });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = response.headers('X-Filename');
                link.click();
            }).catch(() => {
                const message = this.$translate.instant("MESSAGE_DOWNLOAD_MAPPING_FILE_ERROR");
                this.modalService.alert(message);
            });
        }

        public triggerUpload($event) {
            $event.preventDefault();
            // allow angularjs digest to run
            this.$timeout(() => {
                document.getElementById('fileInput').click();
            });
        }

        public uploadImportResults(files) {
            const fileInput = document.getElementById('fileInput') as HTMLInputElement;

            if (files.length !== 1) {
                fileInput.value = '';
                return;
            }

            this.isUploadLinkVisible = false;

            const uploadError = (error) => {
                console.error(error);
                fileInput.value = '';
                this.isUploadLinkVisible = true;
                const message = this.$translate.instant("MESSAGE_UPLOAD_FILE_ERROR");
                this.modalService.alert(message);
            };

            const file = files[0];
            // extension only: Firefox reports the OS-registered MIME type for .csv
            // (application/vnd.ms-excel when Excel is installed), so file.type is not reliable
            if (!file || !file.name.toLowerCase().endsWith('.csv')) {
                uploadError("Uploaded file is not a valid CSV file.");
                return;
            }

            let formData: any = new FormData();
            formData.append('exportHeaderId', this.exportHeaderId);
            formData.append('file', file);

            // this.$http is not sending FormData to server
            let token = window['bearerToken'] || sessionStorage.getItem('mil:meevo:token');
            fetch('api/tokenMigration/importResult', {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                if (!response.ok) {
                    uploadError("File failed to upload.");
                    return;
                }
                this.getTokenMigrationStatus();
            })
            .catch(error => {
                uploadError(error);
            });
        }
    }
}